// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__B5DQe","left":"styles_left__1goSy"};